<div class="flex items-center justify-center h-screen">
    <div class="flex flex-col justify-center items-center">
        <img [src]="logo" alt="Logo" class="mx-auto w-[80%] md:w-[20vw]">
        <div class="bg-white p-4 rounded shadow mt-4 w-[80%] sm:w-[40vw] md:w-[30vw]">
            <form [formGroup]="formLogin" action="">
                <div class="mb-3">
                    <input pInputText type="text" formControlName="user" placeholder="Usuario..." class="form-control">
                    <div *ngIf="formLogin.get('user').invalid && formLogin.get('user').touched" class="login-error">
                        <span *ngIf="formLogin.get('user').errors?.required">El usuario es obligatorio.</span>
                        <span *ngIf="formLogin.get('user').errors?.minlength">Mínimo 3 caracteres.</span>
                    </div>
                </div>

                <div class="mb-3">
                    <input pInputText type="password" formControlName="password" placeholder="Contraseña..."
                        class="form-control">
                    <div *ngIf="formLogin.get('password').invalid && formLogin.get('password').touched"
                        class="login-error">
                        <span *ngIf="formLogin.get('password').errors?.required">La contraseña es obligatoria.</span>
                    </div>
                </div>

                <p *ngIf="error" class="login-error">Usuario o contraseña incorrectos</p>
                <p *ngIf="errorMsg" style="color: red;">{{errorMsg}}</p>

                <div class="d-flex justify-content-center">
                    <button class="btn btn-success" (click)="doLogin()"
                        [disabled]="isDoLoginLoading || formLogin.invalid">
                        <span *ngIf="!isDoLoginLoading">Entrar</span>
                        <span *ngIf="isDoLoginLoading"><i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                            Cargando...</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>